import { formatCurrency, IsNullUndefinedEmpty } from "utils/helper";

export const totalPayment = (selectedOffer, coupon) => {
  let maxInstallments = 0;
  let couponInstallmentsUses = 0;

  if (selectedOffer.price_method === "one_time") {
    return formatCurrency(selectedOffer?.price || 0);
  }

  if (selectedOffer.price_method === "installments") {
    maxInstallments = selectedOffer.n_payments || 0;
  }

  if (selectedOffer.price_method === "recurrence") {
    maxInstallments = selectedOffer.recurrence_max_payments || 0;
  }

  if (coupon && coupon?.active === true) {
    couponInstallmentsUses = coupon?.installments_uses > maxInstallments ? -1 : coupon.installments_uses;
  }
  // console.log("selectedOffer", selectedOffer);
  // console.log("couponInstallmentsUses", couponInstallmentsUses);
  // console.log("maxInstallments", maxInstallments);

  const price = selectedOffer?.price || 0;
  const fullPrice = selectedOffer?.full_price || 0;
  let totalPrice = 0;

  if (couponInstallmentsUses === maxInstallments) {
    totalPrice = formatCurrency(price * maxInstallments);
  } else if (couponInstallmentsUses === -1) {
    totalPrice = formatCurrency(price * maxInstallments);
  } else {
    totalPrice = couponInstallmentsUses * price + (maxInstallments - couponInstallmentsUses) * fullPrice;
  }

  return formatCurrency(totalPrice);

  //formatCurrency(selectedOffer?.price * selectedOffer?.n_payments);
};

export const totalPaymentTooltip = (selectedOffer, coupon, t) => {
  if (selectedOffer.price_method === "installments") {
    return t("pricing.tooltipInstallments", { price: formatCurrency(selectedOffer?.price), total: totalPayment(selectedOffer, coupon) });
  }
  if (selectedOffer.price_method === "recurrence") {
    return t("pricing.recurrenceMaxPayments", { max: selectedOffer?.recurrence_max_payments });
  }
};

const productPrice = (product, mainProduct) => {
  if (IsNullUndefinedEmpty(product)) return <></>;

  let qty = 1;

  if (product?.product_id === mainProduct?.product_id) {
    qty = mainProduct?.qty || 1;
    const total = product?.price * qty;
    return formatCurrency(total);
  }

  return formatCurrency(product?.price);
};

export const showProductsListInfo = (product, mainProduct, hasCoupon, t) => {
  if (IsNullUndefinedEmpty(product)) return <></>;

  if (product?.type === "bump") {
    return <div className="n_intallments">{productPrice(product, mainProduct)}</div>;
  }

  if (product?.price_method === "recurrence") return showProductsListRecurrenceInfo(product, t);
  if (product?.price_method === "installments") return showProductsListInstallmentsInfo(product, hasCoupon);
  return <>{productPrice(product, mainProduct)}</>;
};

const showProductsListInstallmentsInfo = (product, hasCoupon) => {
  if (IsNullUndefinedEmpty(product)) return <></>;
  if (product?.n_payments === 1) return <>{productPrice(product)}</>;

  return (
    <div className="n_intallments">
      {hasCoupon === true ? (
        <span>{productPrice(product)}</span>
      ) : (
        <span>
          {product.n_payments} x {productPrice(product)}
        </span>
      )}
    </div>
  );
};

const showProductsListRecurrenceInfo = (product, t) => {
  let recurrenceFrequencySingular = t("pricing.frequencyMonth");

  if (product.payments_interval > 1) {
    if (product.payments_frequency) {
      recurrenceFrequencySingular = product.payments_frequency === "month" ? t("pricing.frequencyMonths") : t("pricing.frequencyYears");
    }

    return (
      <div className="n_intallments " style={{ textAlign: "right" }}>
        <span style={{ lineHeight: "15px" }}>{productPrice(product)}</span>
        <br />
        <small style={{ lineHeight: "15px" }}>
          {t("pricing.recurrenceEveryInterval", { interval: product.payments_interval, frequency: recurrenceFrequencySingular })}
        </small>
      </div>
    );
  }

  // If payments_interval is 1
  if (product.payments_frequency) {
    recurrenceFrequencySingular = product.payments_frequency === "month" ? t("pricing.frequencyMonth") : t("pricing.frequencyYear");
  }

  return (
    <div className="n_intallments">
      {productPrice(product)} / {recurrenceFrequencySingular}
    </div>
  );
};

export const getOfferData = (offer_id, productData) => productData?.offers.find((offer) => offer.offer_id === offer_id);

export const totalPriceInstallmentsInfo = (mainProduct, otherProducts) => {
  if (otherProducts?.length > 0) return "";
  if (mainProduct?.n_payments > 1) return `${mainProduct?.n_payments} x `;
  return "";
};
